// Some env values are common between many env files; let's factorize them here

export const giphyApi = {
  searchUrl: 'https://api.giphy.com/v1/gifs/search',
  trendingUrl: 'https://api.giphy.com/v1/gifs/trending',
  apiKey: 'jB5yzcF6o22lZ8zbLWJGsZtFixqwswmV',
};

export const ajsClientVersion = 16;

// this function is named devN instead of devX
// because serve-or-build.js replaces all occurences of the text 'devX' in the caller's file
export function devNCommon(devX: string) {
  return {
    production: false,

    // Properties for the angularjs app
    customFieldBaseUrlPrefix: `https://admin-${devX}.alcmeon.com/crm`,
    pdfUploadFrontUrl: `https://pdf-upload-${devX}.alcmeon.com/client`,

    // properties for the angular app
    isTrackActivated: true,
    giphyApi,

    // properties for both
    apiURLPrefix: `https://admin-${devX}.alcmeon.com`,
    wsUrl: `wss://ws-${devX}.alcmeon.com/subscribe`,
    trackURLPrefix: `https://track-${devX}.alcmeon.com/track`,
    ajsClientVersion,
    isBackofficeActivated: false,
    backofficeUrlPrefix: `https://backoffice-${devX}.alcmeon.com/client`,
    frontendURLPrefix: '',
    gaiaURLPrefix: `https://gaia-${devX}.alcmeon.com`,
    sentryDsn: '',
  };
}
